/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import CreateSceneModal from './CreateSceneModal';
import CreateScenePanel from './CreateScenePanel';
import { areRoomIdsTheSame } from './CreateScene.logic';

const CreateScene = props => {
  const {
    rooms,
    docks,
    onSceneInEditChange,
    location,
    onCreateSceneModalCancel
  } = props;
  // eslint-disable-next-line react/destructuring-assignment
  const { state = {} } = location;
  const { scene = {} } = state;
  const [sceneInEdit, setSceneInEdit] = React.useState({
    // eslint-disable-next-line react/destructuring-assignment
    ...props.sceneInEdit,
    ...scene
  });

  React.useEffect(() => {
    onSceneInEditChange(sceneInEdit);
  }, [sceneInEdit]);
  // Need to keep updated name and roomsIds, which can be changed in parent component
  React.useEffect(() => {
    const { name, roomIds } = props.sceneInEdit;

    if (name && name !== sceneInEdit.name) {
      setSceneInEdit({ ...sceneInEdit, name });
    }

    if (roomIds && !areRoomIdsTheSame(roomIds, sceneInEdit.roomIds)) {
      setSceneInEdit({ ...sceneInEdit, roomIds });
    }
    // eslint-disable-next-line react/destructuring-assignment
  }, [props.sceneInEdit]);
  React.useEffect(() => {
    return () => {
      const combinedScene = {
        ...scene,
        actions: [],
        name: '',
        roomIds: null
      };

      if (combinedScene.id) {
        delete combinedScene.id;
      }

      onSceneInEditChange(combinedScene);
    };
  }, []);

  return sceneInEdit.name && Array.isArray(sceneInEdit.roomIds) ? (
    <CreateScenePanel
      rooms={rooms}
      docks={docks}
      sceneInEdit={sceneInEdit}
      onSceneChange={updatedScene =>
        setSceneInEdit({ ...sceneInEdit, ...updatedScene })
      }
    />
  ) : (
    <CreateSceneModal
      onSceneChange={updatedScene =>
        setSceneInEdit({ ...sceneInEdit, ...updatedScene })
      }
      onModalCancel={() => onCreateSceneModalCancel()}
      sceneInEdit={sceneInEdit}
      rooms={rooms}
    />
  );
};

export default CreateScene;
